import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { AdminService } from '../../_services/admin.service';
import { Log } from 'ng2-logger';
import { ActivatedRoute, Router } from '@angular/router';
import { Bridge } from '../../_models/bridge';
import { environment } from '../../../environments/environment';
import { ACLFeature } from '../../_models/acl-feature';

const log = Log.create('SensorDetail');

@Component({
  moduleId: module.id,
  selector: 'edit-bridge',
  styleUrls: ['bridge.less'],
  templateUrl: 'bridge.component.html',
})
export class BridgeComponent implements OnInit {
  bridge: Bridge = new Bridge;
  BASE_URL: string = environment.BASE_URL;
  possibleSensorApplications: any;
  possibleSensorFeatures: any;

  iCanMaintenanceMode: boolean = false;
  readOnly: boolean = true;
  iCanArchive: boolean = false;
  iCanViewArchive: boolean = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private admin: AdminService,
              private toast: ToastsManager) {}

  ngOnInit() {
    this.admin.canI(ACLFeature.WRITE_BRIDGES).subscribe((iCan: boolean) => {
        this.readOnly = !iCan;
    });

    // get bridge controller data
    this.route.params.subscribe(params => {
      this.admin.getBridgeController(params['id']).subscribe((response) => {
        this.bridge = response.data;

        log.d('getBridgeController response', response);
        this.admin.getSensorApplications().subscribe((res) => {
          this.possibleSensorApplications = res.data;
        });

        this.admin.getSensorFeatures().subscribe((res) => {
          this.possibleSensorFeatures = res.data;
        });
      });
    });
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this.bridge[input.model] = input.updatedData;
  }

  private onCancel() {
    this.router.navigate(['/drilldown/bridges']);
  }

  private onSubmit() {
    log.d('onSubmit fired');

    if (this.isVisibleSomewhere() && !this.bridge["image"]) {
      this.toast.error('To make the product visible, please provide an image for the bridge!');
      return;
    }

    this.admin.postBridgeController(this.bridge.id, this.bridge).subscribe((response) => {
      this.toast.success(`Changes have been saved.`);
      log.d('postBridgeController', 'post succesfull', response);

      this.router.navigate(['/drilldown/bridges', {refresh: Date.now()}]);
    });
  }

  private isVisibleSomewhere(): boolean {
    return this.bridge.viewStatus == "1" ||
      this.bridge.viewStatusNa == "1" ||
      this.bridge.viewStatusSa == "1" ||
      this.bridge.viewStatusCn == "1" ||
      this.bridge.viewStatusRoa == "1";
  }
}



// WEBPACK FOOTER //
// ./src/app/bridges/bridge/bridge.component.ts